import { HoverMenu, HoverMenuContent, HoverMenuItem, HoverMenuTrigger } from "@/app/common/common-components/ui/HoverMenu";
import { File, Shield, Store } from "lucide-react";
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router";

type ToolsMenuProps = {
  children: ReactNode;
  toolItems?: {
    label: string;
    icon: React.ReactNode;
    onClick: () => void;
  }[];
};

const ToolsMenu = ({ children, toolItems }: ToolsMenuProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleToolClick = (onClick: () => void) => {
    setOpen(false);
    onClick();
  };

  return (
    <>
      <HoverMenu open={open} onOpenChange={setOpen} openDelay={0} closeDelay={100}>
        <HoverMenuTrigger
          asChild
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
          }}
        >
          {children}
        </HoverMenuTrigger>
        <HoverMenuContent side="bottom" align="start" sideOffset={0} className="tw-rounded-t-none">
          {toolItems?.map((item) => (
            <HoverMenuItem key={item.label} className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2" onClick={() => handleToolClick(item.onClick)}>
              {item.icon}
              {item.label}
            </HoverMenuItem>
          ))}
        </HoverMenuContent>
      </HoverMenu>
    </>
  );
};

export default ToolsMenu;
